import { GlobalStoreCtx } from '@/stores/GlobalStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

import styles from './SunnyLayout.module.scss';

export interface ISunnyLayoutProps {
  className?: string;
  children: {
    header: JSX.Element;
    body: JSX.Element;
  };
  /** 스마트배너 표시 여부. 기본값 `true`. */
  withSmartBanner?: boolean;
  'data-test'?: string;
  bodyClassName?: string;
}

/**
 * 디자인 시스템에 기반한 신규 네비게이션용 레이아웃
 *
 * @example
 * <SunnyLayout ref={elRef}>
 *    {{
 *      header: <FlightListNav />,
 *      body: <FlightListBody affiliateID={affiliateID} cluster={cluster} />,
 *    }}
 * </SunnyLayout>
 */
const SunnyLayout: React.ForwardRefRenderFunction<HTMLDivElement, ISunnyLayoutProps> = (
  { className, children, withSmartBanner = true, 'data-test': testID, bodyClassName },
  ref,
) => {
  const globalStore = useContext(GlobalStoreCtx);
  const showSmartBanner = withSmartBanner && !globalStore.IsPc && globalStore.ShowSmartBanner;

  return (
    <div ref={ref} className={clsx(styles.container, className)} data-test={testID}>
      <header className={styles.headerContainer}>{children.header}</header>

      <main className={clsx(styles.bodyContainer, bodyClassName)}>
        {showSmartBanner && <div className={styles.smartBanner} />}
        {children.body}
      </main>
    </div>
  );
};

export default observer(SunnyLayout, { forwardRef: true });
